import { useQuery } from '@tanstack/react-query'
import { Item } from 'typings'
import { useFetch } from './useFetch'

export function useCategories() {
  const { fetcherWrapper } = useFetch()

  const url = new URL(
    '/api/proxy/catalog_system/pub/category/listall',
    window.location.origin
  )

  async function fetcher() {
    return fetcherWrapper(url)
      .then((r) => r.json())
      .then((categories: Item[]) =>
        categories.map((category) => ({
          id: `${category.id}`,
          name: category.name,
        }))
      )
  }

  return useQuery<Item[]>({ queryKey: ['categories'], queryFn: fetcher })
}
